import React, { useMemo } from 'react'
import { styled } from '~/app/components'
import {
  MarkerDefault,
  MarkerKotel,
  MarkerHAvenue,
  MarkerYAM,
  MarkerYAJA,
  MarkerTrain,
  MarkerLeisure,
  MarkerBus,
  MarkerAccomodation,
} from '~/app/icons'

/**
 * MapMarker component
 * author: soojin.oh
 */

export enum MarkerType {
  DEFAULT = 'DEFAULT',
  KOTEL = 'KOTEL',
  HAVENUE = 'HAVENUE',
  YAM = 'YAM',
  YAJA = 'YAJA',
  GUEST_HOUSE = 'GUEST_HOUSE',
  PENSION = 'PENSION',
  HOTEL = 'HOTEL',
  NORMAL = 'NORMAL',
  MOTEL = 'MOTEL',
  TRAIN = 'TRAIN',
  LEISURE = 'LEISURE',
  BUS = 'BUS',
}

// type definitions
type MapMarkerProps = {
  type: MarkerType
  lat?: number | null
  lng?: number | null
}

// styled components
const Container = styled.div<{ lat: number; lng: number }>`
  width: 3.4rem;
  height: 5.6rem;
  transform: translate3d(0, 0, 0);

  & .${MarkerType.NORMAL} {
    #marker-color {
      fill: #de2e5f;
      stroke: #ba1e4a;
    }
  }

  & .${MarkerType.MOTEL} {
    #marker-color {
      fill: #00e0d1;
      stroke: #00bfb2;
    }
  }

  & .${MarkerType.HOTEL} {
    #marker-color {
      fill: #722c82;
      stroke: #5a2366;
    }
  }

  & .${MarkerType.GUEST_HOUSE} {
    #marker-color {
      fill: #97c91d;
      stroke: #87b219;
    }
  }

  & .${MarkerType.PENSION} {
    #marker-color {
      fill: #ff6659;
      stroke: #d9584c;
    }
  }

  & #marker-outline {
    stroke-opacity: 0;
  }
  :hover {
    & #marker-outline {
      stroke-opacity: 1;
    }
  }
`

// MapMarker component
const MapMarker: React.FunctionComponent<MapMarkerProps> = function ({ type, lat, lng }) {
  const Marker = useMemo(
    () =>
      MarkerType.KOTEL === type
        ? MarkerKotel
        : MarkerType.YAJA === type
          ? MarkerYAJA
          : MarkerType.HAVENUE === type
            ? MarkerHAvenue
            : MarkerType.YAM === type
              ? MarkerYAM
              : MarkerType.TRAIN === type
                ? MarkerTrain
                : MarkerType.LEISURE === type
                  ? MarkerLeisure
                  : MarkerType.BUS === type
                    ? MarkerBus
                    : MarkerType.NORMAL === type
                      ? MarkerAccomodation
                      : MarkerDefault,
    [type]
  )

  if (lat && lng) {
    return (
      <Container lat={lat} lng={lng}>
        <Marker className={type} />
      </Container>
    )
  }
  return null
}

export default React.memo(MapMarker)
